/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Hubspot integration component for Register
//
// When enabled, listens to the localist:order:complete event, and triggers a Hubspot form submission for each attendee.
//
// Usage:
//   Call function during page load

import immutable from 'object-path-immutable';
import * as FieldMapper from './field_mapper';

// Store the page's configuration
let portal_id = null;
let form_id = null;

const log = function() {
  const parts = ['[hubspot] '].concat(Array.prototype.slice.call(arguments));
  return console.log.apply(this, parts);
};

// Look up the field value

// Build an array of form submission(s) for the order
//
// One submission is built for each attendee
//
// Each submission returns the fields property for the Hubspot submission, which is an array of objects with name and value
const buildFormSubmissions = (details, field_mapping) => (() => {
  const result = [];
  for (const attendee of Array.from(details.attendees)) {
  // Promote the current attendee to a top-level item
    var attendee_details = immutable.set(details, 'attendee', attendee);

    log('  Attendee', attendee);

    // and perform the field mapping
    result.push((() => {
      const result1 = [];
      for (const target in field_mapping) {
        const source = field_mapping[target];
        log('    Mapping ', target, 'from', source, ' with ', FieldMapper.lookupValue(attendee_details, source));
        result1.push({
          name: target,
          value: FieldMapper.lookupValue(attendee_details, source, '') || ''
        });
      }
      return result1;
    })());
  }
  return result;
})();

// Submit a form to hubspot, and just log any errors out to console
const submitForms = function(form_submissions) {
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portal_id}/${form_id}`;

  const body = {
    context:        {
                      pageUri:  location.href,
                      pageName: document.title
                    },
    skipValidation: true
  };

  // Extract the hubspotutk cookie, and set it if present
  //
  // Note that adding it to the submission as an empty string causes Hubspot to return an error
  const hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");
  if (hutk !== '') { body.context.hutk = hutk; }

  return (() => {
    const result = [];
    for (let index = 0; index < form_submissions.length; index++) {
      const submission = form_submissions[index];
      body.fields = submission;

      result.push(log('  Submitting form', index, body));
    }
    return result;
  })();
};


// Initialization function for hubspot integration, to apply map
//
// +config+ expects:
//  portal_id: HubSpot portalId
//  form_id: HubSpot formGuid
export const initializeDebugHubspot = function(config) {
  // Store configuration, and ensure it's set
  if (config == null) { config = {}; }
  ({
    portal_id
  } = config);
  ({
    form_id
  } = config);

  if (!portal_id) { throw "HubSpot portal_id must be specified"; }
  if (!form_id) { throw "HubSpot form_id must be specified"; }

  log('Hubspot initialized with portal_id', portal_id, 'form_id', form_id);

  return document.addEventListener('localist:order:complete', function(event) {
    log('Order complete', event.detail);
    const form_submissions = buildFormSubmissions(event.detail, config.fields);

    // Submit each form, logging errors
    return submitForms(form_submissions);
  });
};


namespace('Slzr.Register', (exports, top) => exports.DebugHubspot = function() {
  return initializeDebugHubspot.apply(null, arguments);
});
